import { FC } from 'react';
import GenericError from './GenericError';

const FourZeroFourError: FC = () => {
  return (
    <GenericError
      imageUrl={'/assets/404.png'}
      imageHeight={268}
      imageWidth={200}
      title={'Page Not Found.'}
    />
  );
};

export default FourZeroFourError;
